export * from './detail.component';